var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholderClub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    role: "img",
    "aria-label": "Vereinslogo folgt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 56,
    fill: "#ececef",
    stroke: "#bcbcc4",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-30 60 60)",
    fill: "none",
    stroke: "#9a9aa3",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 60,
    cy: 60,
    rx: 34,
    ry: 21,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 60,
    x2: 80,
    y2: 60,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52,
    y1: 53,
    x2: 52,
    y2: 67,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 52,
    x2: 60,
    y2: 68,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68,
    y1: 53,
    x2: 68,
    y2: 67,
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderClub);
export default __webpack_public_path__ + "static/media/placeholder-club.1382e61931a22bdc991ebcd4aa31cb16.svg";
export { ForwardRef as ReactComponent };